"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormRecaptchaField = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));
var _reactHookForm = require("react-hook-form");
var _models = require("../../models");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file -- not testable */ const FormRecaptchaField = (param)=>{
    let { siteKey, id } = param;
    var _errors_id_message, _errors_id;
    const { getTestId } = (0, _testidGenerator.default)();
    const { setValue } = (0, _reactHookForm.useFormContext)();
    const { errors } = (0, _reactHookForm.useFormState)({
        name: id
    });
    const helperText = (_errors_id = errors[id]) === null || _errors_id === void 0 ? void 0 : (_errors_id_message = _errors_id.message) === null || _errors_id_message === void 0 ? void 0 : _errors_id_message.toString();
    const hasError = !!errors[id];
    const onChange = (0, _react.useCallback)((recaptchaToken)=>{
        if (recaptchaToken === null) {
            setValue(_models.ConcernFormFields.Recaptcha, '');
        } else {
            setValue(_models.ConcernFormFields.Recaptcha, recaptchaToken);
        }
    }, [
        setValue
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_mui.Stack, {
        "data-testid": getTestId(_constants.FORM_RECAPTCHA),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.StyledRecaptcha, {
                direction: "row",
                justifyContent: "flex-start",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactGoogleRecaptcha.default, {
                    sitekey: siteKey,
                    onChange: onChange
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.StyledRecaptchaError, {
                direction: "row",
                justifyContent: "flex-start",
                children: hasError ? helperText : null
            })
        ]
    });
};
exports.FormRecaptchaField = FormRecaptchaField;
